/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable max-len */
import React from 'react'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import AnimatedButton from '../../../../components/Animation/AnimatedButton'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { useContext } from 'react'
import { toggleRowSelection } from '../../../../redux/MultiselectRows'
import { convertEpochToDateFormat } from '../../../../CommonMethods/DateConversion'
import GlobalContext from '../../../../components/Context/GloablContext'
import moment from 'moment'
import { handleEditMessageSent } from '../../../../redux/systemConfigSlice'
import formatMobileNumber from '../../../../CommonMethods/FormatMobileNumber'
const TableBody = ({ tableData,
    List,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    lastIndex,
    setConfirmationState,
    setTextAreaMsg }) => {
    const navigate = useNavigate()
    const auth = useSelector(state => state?.auth)
    const { userType } = auth
    const dispatch = useDispatch()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const [searchParams, setSearchParams] = useSearchParams({})
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const {sendMessageToStartEditing,receiveMessageFromSocket,editSocket,setToastErrorMessage} = useContext(GlobalContext)

    const handelActionButton = async (indexNum) => {
        setSelectedIndex(indexNum)
    }

    const handleCheckboxChange = () => {

        dispatch(toggleRowSelection([tableData?.user_id, pageNumber.toString(), List.data, tableData?.user_name, tableData?.status]))

    };

    const onClickActivation = (e) => {
        e.preventDefault();
        setTextAreaMsg('');
        setSelectedIndex(null);
        setConfirmationState((prev) => ({
            ...prev,
            isOpen: true,
            rowData: tableData,
            multirow: ''
        }))

    }
    // convert date format
    const date=convertEpochToDateFormat(tableData?.created_at,dateformat)
 

    return (
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                cursorpointer
                handleClick={(e) => {
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        navigate(`/manage-provider/${tableData?._id}`, { state: Array.isArray(location.state) ? '' : { "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"), 'search': searchParams.get("search") ? searchParams.get("search") : '' } })
                    }
                }}
                child={
                    <>
                        <td className="px-[18px] py-2  prevent-click  text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            <div className="relative checkbox custom-checkBoxBlue1 provider-tbody">
                                <input type="checkbox" id={tableData.user_id} checked={selectedRows?.some((obj) => obj.id === tableData?.user_id) ? true : false} onChange={() => handleCheckboxChange()} className='prevent-click' />
                                <label htmlFor={tableData.user_id} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click"></label>
                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.user_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.user_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.first_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.last_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.provider_credential=== "" ? "-" :tableData?.provider_credential}</td>
                        <td className="px-[18px] py-2">
                            <div className="flex items-center justify-start">
                                <img loading="lazy" decoding="async" src={`${tableData?.status === "active" ? "/images/active_list_img.svg" : '/images/inactive_list_img.svg'}`} alt="icon" />
                                <span className="text-sm text-start font-normal text-[#031624] pl-2">{tableData?.status === "active" ? "Active" : "Inactive"}</span>
                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.email_address === "" ? "-" : tableData?.email_address}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.mobile_number !== "" ? tableData?.mob_no_country_code+" "+(formatMobileNumber(tableData?.mobile_number)):'-'}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.main_no_country_code + " " + formatMobileNumber(tableData?.main_number)}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.npi_number === "" ? "-" :(formatMobileNumber(tableData?.npi_number))}</td>
                        <td className="pl-[24px] pr-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            <span className={`inline-flex items-center justify-center ${tableData?.block_sms === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[50px] h-[19px]`}>
                                {tableData?.block_sms === true ? "ON" : "OFF"}
                            </span>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            <span className={`inline-flex items-center justify-center ${tableData?.block_email === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[50px] h-[19px]`}>
                                {tableData?.block_email === true ? "ON" : "OFF"}
                            </span>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{date}</td>
                        <td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky right-[-1px] prevent-click ${selectedRows.map((item) => item.id).includes(tableData?.user_id) ? 'bg-[#F8EEF1]' : 'bg-white '} last-td`}>
                            <div className="relative flex items-center justify-center" data-te-dropdown-ref>
                                <button type='button' className="text-white transition duration-150 ease-in-out w-[40px] h-[34px] rounded-[50%] flex justify-center items-center prevent-click"
                                    id={"id"}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() => handelActionButton(indexNum)}
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    data-testid="action-bar"
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/3_dots_list.svg" alt="icon" className="prevent-click" />
                                </button>
                                {selectedIndex === indexNum && <ul style={{marginRight:'2px'}} ref={selectedRef} className={`border border-[#C2DCEF] p-2.5 absolute z-[99] float-left m-0  ${lastIndex === indexNum + 1 ? ' top-[0px]' : ' top-0'} right-[68px] min-w-[135px] list-none rounded-lg  bg-white bg-clip-padding text-left [&[data-te-dropdown-show]]:block prevent-click`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref >

                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => { }}
                                            buttonName={"View"}
                                            locnState={{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),"search_mode":searchParams.get("search_mode"),'search':searchParams.get("search")?searchParams.get("search"):'', provider_id:tableData.user_id }}
                                            link={`/manage-provider/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                          
                                            handleClick={() => {
                                                if(!messageSent){
                                             
                                                    sendMessageToStartEditing(tableData?.user_id)
                                                    let message
                                                    editSocket.onmessage = (event) =>{
                                                        message = event.data
                                                     
                                                        if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                                                      
                                                            navigate(`/manage-provider/add-provider/${tableData._id}`,{state:{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),"search_mode":searchParams.get("search_mode"),'search':searchParams.get("search")?searchParams.get("search"):''}})
                                                        } else{
                                                            dispatch(handleEditMessageSent(false))
                                                          
                                                            { (JSON.parse(message)?.adminId) &&
                                                                setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this provider`)
                                                            }
                                                        }
                                                    }    
                                                }
                                                
                                            }}
                                            buttonName={"Edit"}
                                            locnState={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"), 'search': searchParams.get("search") ? searchParams.get("search") : '', provider_id:tableData.user_id }}
                                            // link={`/manage-provider/add-provider/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px]  py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => { onClickActivation(e) }}
                                            buttonName={`${tableData?.status === "active" ? 'Deactivate' : 'Activate'}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent  hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px]  py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <div className='absolute top-[12px] right-[-9px] rotate-[45deg] w-4 h-4 border-t border-r border-[#C2DCEF] bg-[#fff] z-0'>

                                    </div>
                                </ul>}

                            </div>
                        </td>
                    </>

                } />

        </>
    )
}

export default TableBody